"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.androidWeexBridge = exports.iosWeexBridge = exports.requireModule = void 0;
var STATUS_NO_RESULT = 0;
var STATUS_OK = 1;
var STATUS_ERROR = 2;
var WEEX_IOS_BIZ_SUCCESS_CODE = '0';
var requireModule = function (moduleName) {
    // frame Vue
    if (typeof (__weex_require__) !== 'undefined') {
        return __weex_require__("@weex-module/" + moduleName);
    }
    else if (typeof weex !== 'undefined') {
        return weex.requireModule(moduleName);
    }
};
exports.requireModule = requireModule;
var iosWeexBridge = function () {
    return Promise.resolve(function (method, params) {
        return new Promise(function (resolve, reject) {
            var bridge = exports.requireModule('nuvajs-exec');
            var nameArr = method.split('.');
            var action = nameArr.pop();
            var plugin = nameArr.join('.');
            bridge.exec({
                plugin: plugin,
                action: action,
                args: params,
            }, function (res) {
                if (res && res.errorCode === WEEX_IOS_BIZ_SUCCESS_CODE) {
                    if (typeof params.onSuccess === 'function') {
                        params.onSuccess(res.result);
                    }
                    resolve(res.result);
                }
                else {
                    if (typeof params.onFail === 'function') {
                        params.onFail(res.result);
                    }
                    reject(res.result);
                }
            });
        });
    });
};
exports.iosWeexBridge = iosWeexBridge;
var androidWeexBridge = function () {
    return Promise.resolve(function (method, params) {
        return new Promise(function (resolve, reject) {
            var bridge = exports.requireModule('nuvajs-exec');
            var nameArr = method.split('.');
            var action = nameArr.pop();
            var plugin = nameArr.join('.');
            bridge.exec({
                plugin: plugin,
                action: action,
                args: params,
            }, function (res) {
                var dataAndroid = {};
                try {
                    if (res && res.__message__) {
                        if (typeof res.__message__ === 'object') {
                            dataAndroid = res.__message__;
                        }
                        else {
                            try {
                                dataAndroid = JSON.parse(res.__message__);
                            }
                            catch (error) {
                                if (typeof res.__message__ === 'string') {
                                    dataAndroid = res.__message__;
                                }
                            }
                        }
                    }
                }
                catch (error) {
                    // do nothing
                }
                if (res && parseInt(res.__status__ + '', 10) === STATUS_OK) {
                    if (typeof params.onSuccess === 'function') {
                        params.onSuccess(dataAndroid);
                    }
                    resolve(dataAndroid);
                }
                else {
                    if (typeof params.onFail === 'function') {
                        params.onFail(dataAndroid);
                    }
                    reject(dataAndroid);
                }
            });
        });
    });
};
exports.androidWeexBridge = androidWeexBridge;
